<!-- Header -->
<div mat-dialog-title translate>{{studentTeam == true ? 'Associated Staff' : 'Selected Staff'}}</div>

<!-- Body -->
<mat-dialog-content>

    <div style="flex:1; overflow:auto;">
        <!-- Table -->
        <mat-table [dataSource]="tableData" matSortDisableClear [matSortActive]="isV10 ? 'LastName' : 'StaffName'"
            matSortDirection="asc" matSort>

            <!-- Employee Number -->
            <ng-container matColumnDef="employee-number">
                <mat-header-cell *matHeaderCellDef mat-sort-header="EmployeeNumber">
                    <span translate>{{isV10 ? 'Employee Number' : 'Employee #' }}</span>
                    <filter class="mat-filter" [data]="tableData" columnName="EmployeeNumber" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.EmployeeNumber}}
                </mat-cell>
            </ng-container>

            <!-- First Name -->
            <ng-container matColumnDef="first-name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="FirstName">
                    <span translate>First Name</span>
                    <filter class="mat-filter" [data]="tableData" columnName="FirstName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.FirstName}}
                </mat-cell>
            </ng-container>

            <!-- Middle Name -->
            <ng-container matColumnDef="middle-name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="MiddleName">
                    <span translate>Middle Name</span>
                    <filter class="mat-filter" [data]="tableData" columnName="MiddleName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.MiddleName}}
                </mat-cell>
            </ng-container>

            <!-- Last Name -->
            <ng-container matColumnDef="last-name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="LastName">
                    <span translate>Last Name</span>
                    <filter class="mat-filter" [data]="tableData" columnName="LastName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.LastName}}
                </mat-cell>
            </ng-container>

            <!-- Staff Name -->
            <ng-container matColumnDef="staff-name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="StaffName">
                    Name
                    <filter class="mat-filter" [data]="tableData" columnName="StaffName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff"> {{staff.StaffName}} </mat-cell>
            </ng-container>

            <!-- Primary Job -->
            <ng-container matColumnDef="primary-job">
                <mat-header-cell *matHeaderCellDef mat-sort-header="StaffRole">
                    <span translate>{{isV10 ? 'Primary Job' : 'Role'}}</span>
                    <filter class="mat-filter" [data]="tableData" columnName="StaffRole" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.StaffRole}}
                </mat-cell>
            </ng-container>

            <!-- Primary School -->
            <ng-container matColumnDef="primary-school">
                <mat-header-cell *matHeaderCellDef mat-sort-header="SchoolName">
                    <span translate>{{isV10 ? 'Primary School' : 'School'}}</span>
                    <filter class="mat-filter" [data]="tableData" columnName="SchoolName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff">
                    {{staff.SchoolName}}
                </mat-cell>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="staff-status">
                <mat-header-cell *matHeaderCellDef mat-sort-header="StaffStatus">
                    Status
                    <filter class="mat-filter" [data]="tableData" columnName="StaffStatus" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let staff"> {{staff.StaffStatus}} </mat-cell>
            </ng-container>

            <!-- Row Definitions -->
            <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns; let i = renderIndex;" id="staffListRow{{i}}"
                style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>
        </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons></mat-paginator>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

    <!-- Left -->
    <div class="flex-footer-left"></div>

    <!-- Right -->
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>